<script setup>
import { computed } from 'vue';
import { useEventStore } from '../../../stores/event';
import PgeButton from './../../../pge-components/pge-button.vue';
function handleRedirect() {
  window.location.href = '/'
}
const wrapper = document.querySelector("#wrapper-404")
const eventStore = useEventStore();
const hubName = computed(() => eventStore.event?.value?.login_event_name || '');
const logo = computed(() => eventStore.event?.value?.login_logo || '');
const baseurl = wrapper?.getAttribute('data-base-url') || '';

</script>

<template>
  <div class="container-404">
    <div class="container-404__inner">
      <div class="block-404">
        <div class="block-404__logo-holder">
          <!-- Never a link without a name: a nameless hub's logo says Home, and with
               no logo either there is nothing to show (Back to Main Page goes home). -->
          <a v-if="logo || hubName" class="block-404__brand" href="/">
            <img v-if="logo" :src="logo" :alt="hubName || 'Home'" class="block-404__logo" />
            <b v-else>{{ hubName }}</b>
          </a>
        </div>
        <div class="block-404__content">
          <div class="block-404__content__view-holder">
            <img :src="`${baseurl}/assets/images/session-view.jpg`" alt=""/>
          </div>
          <div class="block-404__content__text">
            <div class="block-404__content__text__text-status">The page you are looking for can't be found.</div>
            <div class="block-404__content__text__code-status">404</div>
            <PgeButton 
              template="outlined" 
              @click="handleRedirect" 
              label="Back to Main Page" 
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container-404 {
  // The prototype's paper (#FCFAFD), not the app-wide grey this used to be.
  background: #fcfafd;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100vw;
  height: 100vh;

  &__inner {
    display: flex;
    padding: var(--spacing-5, 40px);
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-5, 40px);
    flex: 1 0 0;
    align-self: stretch;

    &>div {
      height: 100%;
    }

    .block-404 {
      display: flex;
      padding: var(--spacing-5, 40px);
      gap: var(--spacing-5, 40px);
      flex-direction: column;
      align-items: center;
      flex: 1 0 0;
      align-self: stretch;
      border-radius: var(--Corner-Rad-Primary, 12px);
      background: var(--XL-M-Theme-sys-light-surface-container-lowest, #FFF);

      &__logo-holder {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--spacing-1, 8px);
        align-self: stretch;

        .block-404__brand { color: inherit; text-decoration: none; font-size: 20px; }
        .block-404__logo { display: block; height: 40px; width: auto; max-width: 200px; object-fit: contain; }
      }

      &__content {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: var(--spacing-10, 80px);
        align-self: stretch;
        height: 100%;
        margin-top: -80px;

        &__text {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 20px;

          &__text-status {
            color: var(--XL-M-Theme-sys-light-on-surface, #1E1A1F);
            font-feature-settings: 'liga' off, 'clig' off;

            font-family: Lato, sans-serif;
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px;
            text-align: center;
          }

          &__code-status {
            color: var(--XL-M-Theme-sys-light-on-surface-variant, #4B444D);
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Lato, sans-serif;
            font-size: 100px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }
      }
    }
  }
}
</style>
